import styled from "styled-components";
import {StyleImageButton} from "components/Common/StyleButton";

export const OAuthSignInButtonMedium = styled(StyleImageButton)`
  width: ${() => "250px"};
  height: ${() => "45px"};
`;
